"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconReadHuman = /*#__PURE__*/
function (_Icon) {
  _inherits(IconReadHuman, _Icon);
  function IconReadHuman(props) {
    var _this;
    _classCallCheck(this, IconReadHuman);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconReadHuman).call(this, props));
    _this.name = 'IconReadHuman';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "read-human_svg__group0"
    }, _react2.default.createElement("path", {
      className: "read-human_svg__path0",
      d: "M12 7.501c-2.068 0-3.75-1.682-3.75-3.75S9.932.001 12 .001s3.75 1.682 3.75 3.75-1.682 3.75-3.75 3.75zm0-6.5c-1.516 0-2.75 1.234-2.75 2.75s1.234 2.75 2.75 2.75 2.75-1.234 2.75-2.75-1.234-2.75-2.75-2.75z"
    }), _react2.default.createElement("path", {
      className: "read-human_svg__path1",
      d: "M14.5 17.334c-.551 0-1-.448-1-1v-1.456a.996.996 0 01.712-.957l3.644-1.1a.5.5 0 01.289.956l-3.644 1.1v1.456l3.355-1.013a.5.5 0 01.288.958l-3.356 1.013a.976.976 0 01-.288.043z"
    }), _react2.default.createElement("path", {
      className: "read-human_svg__path2",
      d: "M12 24a.51.51 0 01-.134-.018l-8.268-2.3A1.506 1.506 0 012.5 20.243v-3.309C1.631 16.709 1 15.913 1 15s.631-1.709 1.5-1.934v-2.249c0-.401.156-.778.44-1.061a1.49 1.49 0 011.462-.384l3.167.879a6.599 6.599 0 014.387-2.243L12 8.007a6.608 6.608 0 014.432 2.245l3.167-.879a1.493 1.493 0 011.462.384c.283.283.439.66.44 1.061v2.249C22.369 13.291 23 14.087 23 15s-.631 1.709-1.5 1.934v3.307a1.508 1.508 0 01-1.098 1.441l-8.268 2.3a.518.518 0 01-.131.018H12zm.5-1.159l7.634-2.124a.503.503 0 00.366-.479V17H20a1 1 0 01-1-1v-2a1 1 0 011-1h.5v-2.183a.497.497 0 00-.5-.499.498.498 0 00-.134.018L12.5 12.38v10.461zm-9-2.6a.5.5 0 00.366.477l7.634 2.124V12.38l-7.366-2.045a.498.498 0 00-.487.128.496.496 0 00-.147.354V13H4c.551 0 1 .448 1 1v2c0 .552-.449 1-1 1h-.5v3.241zM20 16h1a1 1 0 000-2h-1v2zM3 14a1.001 1.001 0 000 2h1v-2H3zm9-2.519l3.343-.928A5.54 5.54 0 0012 9.009a5.535 5.535 0 00-3.342 1.544l3.342.928z"
    })));
    return _this;
  }
  return IconReadHuman;
}(_Icon3.default);
exports.default = IconReadHuman;